import API from '../helpers/API'
import { successCode } from '../helpers/constants'
import { handleShortLink } from './dashboard'

const ACTIONS = {
  // login
  LOGIN_PROGRESS: "LOGIN_PROGRESS",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAILED: "LOGIN_FAILED",

  // register
  REGISTER_PROGRESS: "REGISTER_PROGRESS",
  REGISTER_SUCCESS: "REGISTER_SUCCESS",
  REGISTER_FAILED: "REGISTER_FAILED",

  // register
  LOGOUT_PROGRESS: "LOGOUT_PROGRESS",
  LOGOUT_SUCCESS: "LOGOUT_SUCCESS",
  LOGOUT_FAILED: "LOGOUT_FAILED",

  //session expire
  SESSION_EXPIRE: "SESSION_EXPIRE",

  // update
  USER_UPDATE_SUCCESS: "USER_UPDATE_SUCCESS",
}

const updateStatus = (status, statusInfo) => {
  return {
    type: status,
    data: statusInfo
  }
}

export const auth = ({ email, password, history}) => {

  return async (dispatch) => {
    dispatch(updateStatus(ACTIONS.LOGIN_PROGRESS))
    try {
      const result = await API.login({
        user: {
          email: email,
          password: password
        }
      });
      if (result.status === successCode) {
        dispatch(updateStatus(ACTIONS.LOGIN_SUCCESS, result.data))
        dispatch({type: "RESET_IS_KEYWORD_AVAILABLE", data: ""})
        history.push('/dashdoard')
      }
      else {
        dispatch(updateStatus(ACTIONS.LOGIN_FAILED, result.data))
      }
    } catch (err) {
      dispatch(updateStatus(ACTIONS.LOGIN_FAILED, err));
      return err;
    }
  }
};

export const profileUpdate = ({firstname, lastname, history}) => {
  return async (dispatch, getState) => {
    const userId = getState().auth.currentUser.id;
    try {
      const result = await API.userUpdate({ 
        user: {
          id: userId,
          firstname: firstname,
          lastname: lastname
        }
      });
      if (result.status === successCode) {
        dispatch(updateStatus(ACTIONS.USER_UPDATE_SUCCESS, result.data))
      }
      else {
        dispatch(updateStatus(ACTIONS.LOGIN_FAILED, result.data))
      }
    } catch (err) {
      dispatch(updateStatus(ACTIONS.LOGIN_FAILED, err));
      return err;
    }
  }
};

export const reg = ({ email, password, firstname, lastname, history}) => {
  // TODO: fetch reg 
  // dispatch(auth({email, password, history}))
  return async (dispatch) => {
    dispatch(updateStatus(ACTIONS.REGISTER_PROGRESS))
    try {
      const result = await API.register({
        user: {
          email: email,
          password: password,
          firstname: firstname,
          lastname: lastname
        }
      });
      if (result.status === successCode) {
        dispatch(updateStatus(ACTIONS.REGISTER_SUCCESS, result.data))
        history.push('/dashdoard')
      }
      else {
        dispatch(updateStatus(ACTIONS.REGISTER_FAILED, result.data))
      }
    } catch (err) {
      dispatch(updateStatus(ACTIONS.REGISTER_FAILED, err));
      return err;
    }
  }
};

export const logout = ({history}) => {

  // TODO: fetch reg 
  // dispatch(auth({email, password, history}))
  return async (dispatch) => {
    dispatch(updateStatus(ACTIONS.LOGOUT_PROGRESS))
    try {
      const result = await API.logout();
      if (result.status === successCode) {
        dispatch(updateStatus(ACTIONS.LOGOUT_SUCCESS, result.data))
        localStorage.clear()
        history.push('/')
      }
      else {
        dispatch(updateStatus(ACTIONS.LOGOUT_FAILED, result.data))
      }
    } catch (err) {
      dispatch(updateStatus(ACTIONS.LOGOUT_FAILED, err));
      return err;
    }
  }
};

export const sessionExpire = ({history}) => {
  return async (dispatch) => {
    try {
      dispatch(updateStatus(ACTIONS.SESSION_EXPIRE, {}))
      localStorage.clear()
      history.push('/')
    } catch (err) {
      dispatch(updateStatus(ACTIONS.SESSION_EXPIRE, err));
      return err;
    }
  }
};

export const setIsOpenMadal = (value) => dispatch => {
  dispatch({type: "CLOSE_MODAL", data: value})
}

export const resetLoginErrorMessage = () => dispatch => {
  dispatch({type: "RESET_LOGIN_ERROR_MESSAGE", data: ""})
}

export const resetRegisterErrorMessage = () => dispatch => {
  dispatch({type: "RESET_REGISTER_ERROR_MESSAGE", data: ""})
}

export const resetAfterLoggedInFlag = () => dispatch => {
  dispatch({type: "RESET_AFTER_LOGGED_IN_FLAG", data: ""})
}

export const resetCurrentUserState = (user) => dispatch => {
  const userInfo =  JSON.parse(localStorage.getItem("currentUser"))
  dispatch({type: "RESET_CURRENT_USER_DATA", data: user})
}